import type { ReactNode } from "react";

export type MetricValueState = "ok" | "warn" | "error" | "neutral";
export type MetricValueSize = "compact" | "standard" | "headline";

const STATE_COLOR: Record<MetricValueState, string> = {
  ok: "text-status-ok-text",
  warn: "text-status-warn-text",
  error: "text-status-error-text",
  neutral: "text-primary",
};
const SIZE: Record<MetricValueSize, string> = {
  compact: "text-xl",
  standard: "text-3xl",
  headline: "text-kpi-headline",
};

/** Fixed semantic roles, independent of viewport width or dashboard provenance.
 * Long figures remain readable rather than silently ellipsizing numeric data.
 */
export function MetricValue({
  children,
  state = "neutral",
  size = "standard",
  title,
}: {
  children: ReactNode;
  state?: MetricValueState;
  size?: MetricValueSize;
  title?: string;
}) {
  return (
    <div
      data-metric-size={size}
      className={`min-w-0 max-w-full [overflow-wrap:anywhere] font-bold tracking-display tabular-nums ${SIZE[size]} ${STATE_COLOR[state]}`}
      title={title}
    >
      {children}
    </div>
  );
}
